import React, { useState, useEffect, useRef, useCallback } from "react"
import { useHistory, useLocation } from "react-router-dom"
import {
	DataGrid,
	GridToolbarContainer,
	GridToolbarColumnsButton,
	GridToolbarFilterButton,
	GridToolbarExport,
	GridToolbarDensitySelector,
} from "@mui/x-data-grid"
import { Box, Typography } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import Skeleton from "@material-ui/lab/Skeleton"
import { useTheme } from "@material-ui/core/styles"
import { makeStyles } from "@material-ui/core"
import ViewWeekIcon from "@material-ui/icons/ViewWeek"
import CircularProgress from "@material-ui/core/CircularProgress"
import DownloadSVG from "../../../components/icons/DownloadSVG"
import "./TableView.css"
import { useDispatch, useSelector } from "react-redux"
import { setReviewAsignee, setReviewAssigneeMap } from "../../../actions/reviewActions"
import _ from "lodash"
import ShowDuplicateSwitch from "../Switch/ShowDuplicateSwitch"
import { LAST_OPENED_FILE_ID, formatFileSize } from "../../../utils"
import { resetSelectedIdsAction } from "../../../actions/downloadsActions"
import SearchInSubject from "./SearchInSubject"

const TableView = (props) => {
	const {
		columns,
		rows,
		isLoading,
		pageInfo,
		onDataRequest,
		defaultSortBy,
		checkboxSelection,
		sortInfo,
		footerInfo,
		topBarInfo,
		totalCountText,
		userSelectedRows,
		showDownloadButton,
		showColumnsButton,
		toApplyHotKeys = false,
		showDuplicate = false,
	} = props

	const theme = useTheme()
	const [t] = useTranslation("global")
	const isReviewFormOpen = useSelector((state) => state.review?.isReviewFormOpen)
	const maxAllowedDownloadSize = useSelector((state) => state?.info?.version?.max_allowed_download_size)
	const location = useLocation()

	const useStyles = makeStyles((theme) => ({
		root: {
			...theme.typography.subtitle2,
			border: "none",
			"& .MuiDataGrid-columnsContainer": {
				borderBottom: `1px solid ${theme.palette.divider}`,
			},
			"& .MuiDataGrid-cell": {
				borderBottom: `1px solid ${theme.palette.divider}`,
			},
			"& .MuiCheckbox-colorPrimary.Mui-checked": {
				color: theme.palette.primary.dark,
			},
			"& .MuiDataGrid-overlay": {
				background: theme.palette.grey.D500,
				zIndex: 1,
				opacity: 0.6,
			},
			"& .MuiDataGrid-columnHeaderWrapper": {
				background: theme.palette.grey[50],
				border: "none",
				fontWeight: theme.typography.subtitle1.fontWeight,
				"&:focus": {
					outline: "none",
				},
			},
			"& .MuiDataGrid-row.Mui-selected": {
				background: theme.palette.grey.D500,
			},
			"& .MuiDataGrid-row": {
				...theme.typography.body2,
				"& .MuiDataGrid-cell": {
					"&:focus": {
						outline: "none",
					},
				},
			},
			"& .MuiDataGrid-sortIcon": {
				color: theme.palette.grey.D100,
			},
			"& .keyboard-selected-row": {
				backgroundColor: theme.palette.action.hover,
				boxShadow: `0 1px 9px 1px ${theme.palette.grey.D100}`,
				zIndex: 2,
				position: "relative",
			},
			"& .MuiDataGrid-footerContainer": {
				justifyContent: isReviewFormOpen ? "start" : "space-between",
			},
		},
	}))
	const classes = useStyles()
	const history = useHistory()
	const dataGridRef = useRef(null)
	const dispatch = useDispatch()
	const [selectedRows, setSelectedRows] = useState([])
	const [keydownSelectedRow, setKeydownSelectedRow] = useState(localStorage?.getItem(LAST_OPENED_FILE_ID) || null)

	//review setup
	const reviewCurrentAsignee = useSelector((state) => state.review?.reviewCurrentAsignee)
	const reviewAssignee = useSelector((state) => state.review?.reviewAssignee)
	const selectedRowFromRedux = useSelector((state) => state.downloads?.selectedDocumentIds)
	// Subject search
	const fileTypesFilter = useSelector((state) => state.filter?.fileTypes)

	const currUrl = location.pathname

	const getSelectedRow = (SelectedIds) => {
		userSelectedRows(SelectedIds)
		setSelectedRows(SelectedIds)
	}

	/**
	 * If review form is open clear the previous selection
	 */
	useEffect(() => {
		if (isReviewFormOpen) {
			getSelectedRow([])
		}
	}, [isReviewFormOpen])

	useEffect(() => {
		return () => {
			dispatch(resetSelectedIdsAction())
		}
	}, [])
	function CustomToolbar() {
		return (
			<Box>
				<Box
					sx={{
						padding: "16px",
						display: "flex",
						justifyContent: "space-between",
						width: "100%",
					}}
				>
					<div style={{ width: "50%", display: "flex" }}>
						<Typography
							variant="body2"
							style={{ ...theme.typography.subTitle2, color: theme.palette.grey.D100 }}
							component="span"
						>
							{totalCountText}

							<span>
								{Object.values(selectedRowFromRedux)?.length !== 0 &&
									` | ${Object.values(selectedRowFromRedux)?.length} Files Selected `}
							</span>
						</Typography>
						{currUrl !== "/build-concept" ? fileTypesFilter?.includes("email") ? <SearchInSubject /> : null : null}
					</div>
					<div style={{ width: "50%", display: "flex", justifyContent: "flex-end" }}>
						{showColumnsButton
							? {
									/* <GridToolbarContainer>
							<GridToolbarColumnsButton startIcon={<ViewWeekIcon color="primary.dark" />} />
						</GridToolbarContainer> */
							  }
							: null}
						{showDuplicate ? <ShowDuplicateSwitch /> : null}
						{showDownloadButton ? (
							Object.values(selectedRowFromRedux)?.length !== 0 &&
							maxAllowedDownloadSize >= Object.values(selectedRowFromRedux).reduce((a, b) => a + b, 0) ? (
								<div
									style={{ display: "flex", alignItems: "center ", cursor: "pointer" }}
									onClick={props?.bulkDownloadEvent}
								>
									{props?.bulkDownloadStatus?.downloading ? <CircularProgress size={20} /> : <DownloadSVG />}
								</div>
							) : (
								<div style={{ display: "flex", alignItems: "center", opacity: "0.3" }}>
									<DownloadSVG />
								</div>
							)
						) : null}
						{topBarInfo.rightSection}
					</div>
				</Box>
				{Object.values(selectedRowFromRedux)?.length !== 0 && (
					<Box
						sx={{
							padding: "16px",
							display: "flex",
							justifyContent: "center",
							width: "100%",
						}}
					>
						<Typography
							variant="body2"
							style={{ ...theme.typography.subTitle2, color: theme.palette.grey.D100 }}
							component="span"
						>
							<span>{`${formatFileSize(Object.values(selectedRowFromRedux).reduce((a, b) => a + b, 0))} ${t(
								"maxSize.of"
							)} ${formatFileSize(maxAllowedDownloadSize)} ${t("maxSize.limitSelected")} `}</span>
							{maxAllowedDownloadSize < Object.values(selectedRowFromRedux).reduce((a, b) => a + b, 0) && (
								<span style={{ ...theme.typography.subTitle2, paddingLeft: "5px", color: theme.palette.error.main }}>
									{t("maxSize.downloadFileSize")}
								</span>
							)}
						</Typography>
					</Box>
				)}
			</Box>
		)
	}

	const setSelectedRow = (id) => {
		if (!toApplyHotKeys) return
		const rowDom = window.document.querySelector('[data-id="' + id + '"]')
		rowDom?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" })
	}

	const goToViewerHandler = (rowId) => {
		if (isReviewFormOpen) return //if create/update review is open then will prevent to document in viewer
		if (rowId)
			history.replace({
				pathname: `${location?.pathname}/viewer/${rowId}`,
				search: window?.location?.search,
				state: { prevPath: history?.location?.pathname },
			})
	}

	useEffect(() => {
		if (!toApplyHotKeys) return
		keydownSelectedRow && setSelectedRow(keydownSelectedRow)
	}, [keydownSelectedRow])

	const handleClickOusideTheRows = useCallback((e) => {
		const targetDiv = document.querySelector(".MuiDataGrid-renderingZone")
		const isClickedInsideDiv = e.composedPath().includes(targetDiv)

		if (!isClickedInsideDiv) {
			setKeydownSelectedRow((prev) => null)
			document.removeEventListener("click", handleClickOusideTheRows)
		}
	}, [])

	return (
		<Box
			style={{
				width: "100%",
				background: theme.palette.common.white,
				border: `solid 1px ${theme.palette.grey.D400}`,
				borderRadius: "5px",
				height: "100%",
			}}
		>
			<DataGrid
				className={classes.root}
				rows={rows}
				columns={columns}
				loading={isLoading}
				autoHeight
				localeText={{ toolbarColumns: "" }}
				disableSelectionOnClick
				page={pageInfo.page - 1}
				pageSize={pageInfo.pageSize}
				rowsPerPageOptions={pageInfo.rowsPerPageOptions}
				pagination
				onPageChange={(newPage) => pageInfo.handlePageChange(newPage + 1)}
				onPageSizeChange={pageInfo.handlePageSizeChange}
				paginationMode={pageInfo.paginationMode}
				rowCount={pageInfo.totalRowCount}
				sortingOrder={["asc", "desc"]}
				sortingMode={sortInfo.sortingMode}
				sortModel={sortInfo.sortModel}
				onSortModelChange={sortInfo.onSortModelChange}
				checkboxSelection={false}
				hideFooter={footerInfo.hideFooter}
				hideFooterSelectedRowCount={footerInfo.hideSelectionCount}
				hideFooterPagination={footerInfo.hidePagination}
				components={
					topBarInfo.show
						? {
								Toolbar: CustomToolbar,
						  }
						: {}
				}
				onSelectionModelChange={(ids) => {
					getSelectedRow(ids)
				}}
				selectionModel={selectedRows}
				disableColumnMenu={true}
				onCellKeyDown={(params, event) => {
					if (!toApplyHotKeys) return
					event.preventDefault()
					event.stopPropagation()
					if (event.key === "Enter") {
						goToViewerHandler(keydownSelectedRow)
					} else if (event.key === "ArrowUp" || (event.key === "ArrowDown" && keydownSelectedRow)) {
						const selectedRowIndex = rows?.findIndex(({ id }) => keydownSelectedRow === id)
						if (selectedRowIndex >= 0) {
							if (selectedRowIndex === 0 && event.key === "ArrowUp") return
							if (selectedRowIndex === rows?.length - 1 && event.key === "ArrowDown") return
							const newRow = event.key === "ArrowUp" ? rows?.[selectedRowIndex - 1] : rows?.[selectedRowIndex + 1]
							setKeydownSelectedRow((prevId) => newRow?.id)
						}
					}
				}}
				onRowClick={(params, event) => {
					if (!toApplyHotKeys) return
					event.preventDefault()
					event.stopPropagation()
					setKeydownSelectedRow((prevId) => params?.id)
					document.addEventListener("click", handleClickOusideTheRows)
				}}
				getRowClassName={(params) => {
					if (!toApplyHotKeys) return
					return params?.id === keydownSelectedRow ? "keyboard-selected-row" : ""
				}}
				onColumnHeaderClick={(params, event) => {
					if (!toApplyHotKeys) return
					keydownSelectedRow && setKeydownSelectedRow((prevId) => null)
				}}
			/>
		</Box>
	)
}

export default TableView
